<template functional>
  <div>
    <span
      v-if="
        props.column === 'ExecutionPercentage' ||
        props.column === 'WeekBeforeAdvance' ||
        props.column === 'ActualWeekAdvance'
      "
      :class="{
        rojo: $options.ismenor80(props),
        amarillo: $options.ismenor100(props),
        verde: $options.is100(props)
      }"
      >{{ props.rowValue }} %</span
    >
    <span
      class="rojo"
      v-if="props.column === 'DelayedDays' && props.rowValue > 0"
    >
      {{ props.rowValue }}
    </span>
    <span v-else-if="props.column === 'DelayedDays' && props.rowValue <= 0">
      0
    </span>
  </div>
</template>

<script>
export default {
  name: "PercentageAndColorFormatter",
  ismenor80({ rowValue }) {
    return rowValue < 80;
  },

  ismenor100({ rowValue }) {
    return rowValue >= 80 && rowValue < 100;
  },
  is100({ rowValue }) {
    return rowValue === 100;
  }
};
</script>

<style scope>
.rojo {
  color: red;
}
.amarillo {
  color: darkorange;
}
.verde {
  color: green;
}
</style>
